import { localStorageHelper } from "@offstreetparking/design-system/utils";

const STORAGE_KEY = "portal_touchnet_pending_permit";

// The redirect to uPay unloads the SPA, so the data addPermit needs (the access token never
// leaves the browser) is stashed here before navigating away and promoted into saved permits
// when the parker lands back on the confirmation page.
export type PendingSavedPermit = {
	locationLookupId: string;
	publicIdentifier: string;
	publicAccessToken: string;
};

export const stashPendingSavedPermit = (pending: PendingSavedPermit) => {
	localStorageHelper.setItem(STORAGE_KEY, pending);
};

export const takePendingSavedPermit = (publicIdentifier: string): PendingSavedPermit | null => {
	const pending: Partial<PendingSavedPermit> | null = localStorageHelper.getItem(STORAGE_KEY);
	if (
		!pending ||
		pending.publicIdentifier !== publicIdentifier ||
		!pending.locationLookupId ||
		!pending.publicAccessToken
	) {
		return null;
	}
	localStorageHelper.removeItem(STORAGE_KEY);
	return {
		locationLookupId: pending.locationLookupId,
		publicIdentifier: pending.publicIdentifier,
		publicAccessToken: pending.publicAccessToken,
	};
};
